import MoneyBackGuarantee from '../src/MoneyBackGuarantee/index';
export default MoneyBackGuarantee;
